module.exports = __webpack_public_path__ + "static/media/pricemain.532f85d9.png";